<template>
    <login-form></login-form>
</template>

<script>
    import LoginForm from "../components/Auth/LoginForm";
    import api from '../http';

    export default {
        name: "Login",
        components: {
            LoginForm
        },
        created() {
            api.get('/accounts/get-csrf/');
        }
    }
</script>

<style scoped>

</style>